import { store } from '@/store';

export const checkRoutePermissions = (routeName) => {
  const permissions = store.getters['generic/permissionsList'][routeName];
  return ((routeName === 'login' || routeName === 'index') || (!_.isEmpty(permissions) && permissions.view))
};

export const setUserPermission = (routeName) => {
  const permissions = store.getters['generic/permissionsList'][routeName];
  store.commit('generic/setCurrentRoutePermissions', permissions);
};



// WEBPACK FOOTER //
// ./src/routes/routeController.js